import { getDocument } from "@/utils/firebase";

export const getShop = (id: string) => getDocument("stores", id);

export const getShopAggregations = (id: string) =>
  getDocument("aggregations", id);
